// extracted by mini-css-extract-plugin
export default {"pending__title":"PaymentTable_pending__title__e+gyl","pending__table":"PaymentTable_pending__table__nQHer","pending__table_header":"PaymentTable_pending__table_header__olgqr"};